<template>
  <page-content v-has-permission="'moshop_shop_feature_view'">

    <panel ref="searchFormPanel" :is-open.sync="showFormSearch" show-close show-collapse title="Thông tin tìm kiếm">
      <c-form ref="searchForm" @submit="search()">

        <b-row>
          <c-input v-model.trim="searchForm.shopCode" form-group-class="col-md-6 col-sm-6" label="Mã shop"/>

          <c-select2 label="Tính năng" form-group-class="col-md-6 col-sm-6" v-model="searchForm.type">
            <option>-- Chọn tính năng --</option>
            <option :value="item" v-for="item in listFeature">{{item}}</option>
          </c-select2>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>
            <button class="btn btn-secondary" type="reset" @click="resetFormSearch()">
              <i class="fas fa-redo-alt"></i>
              Xóa bộ lọc
            </button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel ref="panel" show-collapse title="Danh sách hành động">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="showFormSearch = !showFormSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="searchForm"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Shop code', sortField:'shop_code', sortable: true},
                   {text: 'Tính năng', sortField:'type', sortable: true},
                   {text: 'Thời gian tạo', sortField:'created', sortable: true},
                   {text: 'Thời gian cập nhật', sortField:'modified', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
               uri="/moshop/api/fulfilment/config/shop/search"
               :process-res-data="processData"
               :process-req-data="processReqData"
      >
        <template #button>
          <b-button v-if="hasPermission('moshop_shop_feature_create')"
                    size="sm"
                    variant="success"
                    @click="$refs.formCreate.open()"
          >
            <i class="fas fa-plus-circle"></i> Thêm mới
          </b-button>

          <b-button v-if="hasPermission('moshop_shop_feature_delete')"
                    size="sm"
                    variant="danger"
                    @click="$refs.formDelete.open()"
          >
            <i class="far fa-trash-alt"></i> Xóa tính năng cho nhiều shop
          </b-button>
        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.shop_code }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.created | datetime }}</td>
          <td>{{ item.modified | datetime }}</td>
          <td class="text-center">

            <b-button
                v-if="hasPermission('moshop_shop_feature_delete')"
                class="btn btn-icon"
                title="Xóa"
                type="button"
                variant="danger"
                @click="deleteItem(item)"
            >
              <i class="far fa-trash-alt"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>

    <add ref="formCreate" @success="search()" :list-feature="listFeature"/>
    <delete-multi ref="formDelete" @success="search()" :list-feature="listFeature"/>
    <delete ref="deleteConfirmDialog" @success="search()"/>
  </page-content>
</template>

<script>
import Add from './Add';
import Delete from './Delete';
import httpMixins from "@/mixins/httpMixins";
import DeleteMulti from "@/pages/Moshop/FeatureShop/DeleteMulti";

export default {
  name: "Index",
  mixins:[
    httpMixins
  ],
  components: {
    Add,
    Delete,
    DeleteMulti,
  },
  data() {
    return {
      searchForm: {
        shopCode: null,
        type: null
      },
      listFeature: [],
      showFormSearch: true
    }
  },
  methods: {
    search() {
      this.$refs.table.reload();
    },
    resetFormSearch() {
      this.searchForm.shopCode = null;
      this.searchForm.type = null;

      this.search();
    },
    update(item) {
      this.$refs.formUpdate.open(item.id);
    },
    deleteItem(item) {
      this.$refs.deleteConfirmDialog.open(item);
    },
    processData(data){
      if(data.success){
        return {
          data: data.data.data,
          recordsFiltered: data.data.total,
        }
      } else {
        return {
          data: [],
          recordsFiltered: 0
        }
      }
    },
    processReqData(data){
      return {
        page: data.page,
        page_size: data.pageSize,
        type: this.searchForm.type,
        shop_code: this.searchForm.shopCode
      }
    }
  },
  mounted() {
    this.$http.get("/moshop/api/fulfilment/config/shop/list-feature")
    .then(res => {
      let data = res.data;
      if(data.success){
        this.listFeature = data.data;
      } else {
        this.$error(data.message);
      }
    }).catch(error => {
      this.errorNotify(error);
    })
  }
}
</script>

<style scoped>

</style>